/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link} from 'react-router-dom'
import moment from 'moment'
import {saveAs} from 'file-saver'
import FromToPicker from '../BaseComponent/FromToPicker'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import Select from 'react-select'
import http from '../Interceptor/Interseptor'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import USER_MANAGE from '../BaseComponent/USERMANAGE'

class DriverProviders extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      fromDate: '',
      toDate: '',

      Drivers: []
    }
  }
  componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  submit(e) {
    e.preventDefault()
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getReport() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let driverId =
      this.state.selectedOption == null || this.state.selectedOption == '' ? '' : this.state.selectedOption.personId
    let driverName =
      this.state.selectedOption == null || this.state.selectedOption == '' ? '' : this.state.selectedOption.name
    if (driverId === '') {
      message.error('رساننده را وارد کنید')
    } else if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/dispatch/driver/providers?&driverId=${driverId}&driverName=${driverName}&fromTime=${minDate}&toTime=${maxDate}`
      )
    }
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
    // alert(JSON.stringify(selectedOption))
    console.log(`Option selected:`, selectedOption)
  }

  render() {
    let {selectedOption} = this.state

    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
            <li>گزارش تامین کننده های رساننده</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>گزارش تامین کننده های رساننده</p>
            </div>

            <FromToPicker
              onChangeFromDate={this.handleChangeFromDate}
              onChangeToDate={this.handleChangeToDate}
              fromLabel="تاریخ شروع از"
              toLabel="تاریخ شروع تا"
              force={true}
              defaulValue={true}
              fromId="from"
              toId="to"
            />
            <div className="formComponent">
              <label className="font-weight-bold">
                رساننده :‌
                <span className="requireFiled">*</span>
              </label>
              <Select
                value={selectedOption}
                onChange={this.handleChange}
                options={this.state.Drivers}
                isMulti={false}
                isClearable={true}
                placeholder={''}
                id="input_supplierName"
                name="input_supplierName"
                tabIndex="1"
              />
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getReport.bind(this)}>
                دریافت گزارش
              </button>

              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default DriverProviders
